export default {
  'login.title': 'Inicio de sesion de administrador',
  'login.subtitle': 'Inicie sesion con su cuenta de administrador, asignada por el super administrador',
  'login.email': 'Usuario / Correo electronico',
  'login.emailPlaceholder': 'Ingrese su usuario o correo electronico',
  'login.password': 'Contrasena',
  'login.passwordPlaceholder': 'Ingrese su contrasena',
  'login.submit': 'Iniciar sesion',
  'login.loading': 'Iniciando sesion...',
  'login.failed': 'Error de inicio de sesion',
  'login.networkError': 'Error de red',
  'login.unknownError': 'Error desconocido',
  'login.emptyFields': 'Por favor ingrese usuario y contrasena',
  'login.showPassword': 'Mostrar contrasena',
  'login.hidePassword': 'Ocultar contrasena',
  'login.noSelfRegister': 'El auto-registro no esta disponible. Contacte a su super administrador para crear una cuenta.',
  'login.footerText': 'Plataforma de Gestion Multi-inquilino',
  'login.brandTitle1': 'Consola',
  'login.brandTitle2': 'Multi-inquilino',
  'login.brandSlogan': 'Gestion unificada de inquilinos, usuarios, recursos y politicas de facturacion para operaciones mas eficientes y seguras.',
  'login.feature1Title': 'Control de acceso',
  'login.feature1Desc': 'Control de acceso empresarial y registros de auditoria',
  'login.feature2Title': 'Aislamiento de datos',
  'login.feature2Desc': 'Aislamiento de datos multi-inquilino y gestion de cuotas',
  'login.feature3Title': 'Monitoreo',
  'login.feature3Desc': 'Paneles de monitoreo en tiempo real y analisis de informes',
  'sidebar.home': 'Panel de control',
  'sidebar.users': 'Usuarios y Permisos',
  'sidebar.resources': 'Funciones y Recursos',
  'sidebar.tenants': 'Gestion de Inquilinos',
  'sidebar.audit': 'Registro de Auditoria',
  'sidebar.reports': 'Informes',
  'sidebar.settings': 'Configuracion',
  'sidebar.admin': 'Administrador',
  'header.search': 'Buscar inquilinos, usuarios, recursos...',
  'header.notifications': 'Notificaciones',
  'header.viewAll': 'Ver todas las notificaciones',
  'header.profile': 'Perfil',
  'header.settings': 'Configuracion',
  'header.logout': 'Cerrar sesion',
  'header.notif.newTenant': 'Nuevo inquilino registrado',
  'header.notif.newTenantMsg': 'Tech Innovation S.L. se ha registrado',
  'header.notif.apiWarning': 'Alerta de uso de API',
  'header.notif.apiWarningMsg': 'Inquilino T002 cerca del limite de cuota',
  'header.notif.systemUpdate': 'Actualizacion del sistema',
  'header.notif.systemUpdateMsg': 'Mantenimiento del sistema esta noche',
  'header.notif.5minAgo': 'Hace 5 min',
  'header.notif.1hourAgo': 'Hace 1 hora',
  'header.notif.3hoursAgo': 'Hace 3 horas',
  'home.title': 'Panel de Control',
  'home.subtitle': 'Bienvenido, esta es su plataforma de gestion multi-inquilino',
  'home.totalTenants': 'Total Inquilinos',
  'home.totalUsers': 'Total Usuarios',
  'home.apiCalls': 'Llamadas API',
  'home.totalRevenue': 'Ingresos Totales',
  'home.totalSkills': 'Total Habilidades',
  'home.chatSessions': 'Sesiones de Chat',
  'home.totalMessages': 'Total Mensajes',
  'home.systemHealth': 'Salud del Sistema',
  'home.active': 'activos',
  'home.activeShort': 'activos',
  'home.thisMonth': 'Este mes',
  'home.published': 'publicados',
  'home.cumulative': 'Acumulado',
  'home.running': 'Funcionando normalmente',
  'home.vsLastMonth': 'vs mes anterior',
  'home.apiTrend': 'Tendencia de Uso API',
  'home.revenueTrend': 'Tendencia de Ingresos',
  'home.quickAccess': 'Acceso Rapido',
  'home.recentActivity': 'Actividad Reciente',
  'home.viewAll': 'Ver todo',
  'home.tenantDistribution': 'Distribucion de Inquilinos',
  'home.success': 'Exitoso',
  'home.failed': 'Fallido',
  'tenants.title': 'Gestion de Inquilinos',
  'tenants.subtitle': 'Gestionar configuracion, cuotas y politicas de facturacion',
  'tenants.export': 'Exportar Lista',
  'tenants.create': 'Nuevo Inquilino',
  'tenants.total': 'Total',
  'tenants.unit': 'inquilinos',
  'tenants.clickTip': 'Haga clic en una fila para ver detalles',
  'tenants.showing': 'Mostrando',
  'tenants.to': '-',
  'tenants.of': 'de',
  'tenants.records': 'registros',
  'tenants.createTitle': 'Nuevo Inquilino',
  'tenants.createSuccess': 'Inquilino creado exitosamente!',
  'tenants.createFailed': 'Error al crear',
  'tenants.tenantName': 'Nombre del Inquilino',
  'tenants.subdomain': 'Subdominio',
  'tenants.contactName': 'Nombre de Contacto',
  'tenants.contactEmail': 'Email de Contacto',
  'tenants.planType': 'Tipo de Plan',
  'tenants.deployRegion': 'Region de Despliegue',
  'tenants.cancel': 'Cancelar',
  'tenants.createBtn': 'Crear Inquilino',
  'tenants.namePlaceholder': 'ej: Tech Innovation S.L.',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': 'Juan Garcia',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'Basico',
  'tenants.plan.professional': 'Profesional',
  'tenants.plan.enterprise': 'Empresarial',
  'tenants.region.east': 'China Este',
  'tenants.region.north': 'China Norte',
  'tenants.region.south': 'China Sur',
  'tenants.region.west': 'China Oeste',
  'tenantStats.total': 'Total Inquilinos',
  'tenantStats.active': 'Inquilinos Activos',
  'tenantStats.totalUsers': 'Total Usuarios',
  'tenantStats.monthlyRevenue': 'Ingresos Mensuales',
  'tenantFilters.search': 'Buscar nombre, dominio o contacto...',
  'tenantFilters.allPlans': 'Todos los Planes',
  'tenantFilters.allStatus': 'Todos los Estados',
  'tenantFilters.active': 'Activo',
  'tenantFilters.suspended': 'Suspendido',
  'tenantFilters.trial': 'Prueba',
  'tenantTable.info': 'Info Inquilino',
  'tenantTable.plan': 'Plan',
  'tenantTable.status': 'Estado',
  'tenantTable.users': 'Usuarios',
  'tenantTable.apiCalls': 'Llamadas API',
  'tenantTable.storage': 'Almacenamiento',
  'tenantTable.region': 'Region',
  'tenantTable.lastActive': 'Ultima Actividad',
  'tenantTable.actions': 'Acciones',
  'tenantTable.viewDetail': 'Ver detalles',
  'tenantTable.edit': 'Editar',
  'tenantTable.more': 'Mas',
  'tenantTable.noMatch': 'No se encontraron inquilinos',
  'tenantDetail.overview': 'Resumen',
  'tenantDetail.quotaMgmt': 'Gestion de Cuotas',
  'tenantDetail.dataIsolation': 'Aislamiento de Datos',
  'tenantDetail.billing': 'Facturacion',
  'tenantDetail.createdAt': 'Creado el',
  'tenantDetail.resourceUsage': 'Uso de Recursos',
  'tenantDetail.apiCallUsage': 'Llamadas API',
  'tenantDetail.storageUsage': 'Almacenamiento',
  'tenantDetail.userCount': 'Numero de Usuarios',
  'tenantDetail.contactInfo': 'Informacion de Contacto',
  'tenantDetail.contact': 'Contacto',
  'tenantDetail.email': 'Email',
  'tenantDetail.deployRegion': 'Region de Despliegue',
  'tenantDetail.lastActive': 'Ultima Actividad',
  'tenantDetail.enabledFeatures': 'Funciones Habilitadas',
  'tenantDetail.tags': 'Etiquetas',
  'tenantDetail.quickActions': 'Acciones Rapidas',
  'tenantDetail.suspend': 'Suspender Inquilino',
  'tenantDetail.resume': 'Reactivar Inquilino',
  'tenantDetail.sendNotice': 'Enviar Notificacion',
  'tenantDetail.simulateLogin': 'Simular Inicio de Sesion',
  'tenantDetail.exportData': 'Exportar Datos',
  'tenantDetail.quotaSaved': 'Cuota guardada',
  'tenantDetail.quotaSettings': 'Configuracion de Cuotas',
  'tenantDetail.quotaDesc': 'Ajustar limites de recursos para este inquilino',
  'tenantDetail.maxUsers': 'Max Usuarios',
  'tenantDetail.apiCallsMonth': 'Llamadas API / Mes',
  'tenantDetail.storageSpace': 'Almacenamiento',
  'tenantDetail.currentUsage': 'Uso actual',
  'tenantDetail.saveQuota': 'Guardar Cuotas',
  'tenantDetail.isolationSaved': 'Politica de aislamiento guardada',
  'tenantDetail.isolationPolicy': 'Politica de Aislamiento',
  'tenantDetail.isolationDesc': 'Elegir metodo de almacenamiento y aislamiento',
  'tenantDetail.dedicated': 'Aislamiento Dedicado',
  'tenantDetail.dedicatedDesc': 'Instancia de base de datos dedicada, aislamiento completo, maxima seguridad',
  'tenantDetail.shared': 'Aislamiento Compartido',
  'tenantDetail.sharedDesc': 'Instancia compartida con seguridad a nivel de fila, menor costo',
  'tenantDetail.recommended': 'Recomendado',
  'tenantDetail.permissionConfig': 'Configuracion de Permisos',
  'tenantDetail.crossTenantAccess': 'Acceso entre Inquilinos',
  'tenantDetail.crossTenantDesc': 'Permitir acceso a datos publicos de otros inquilinos',
  'tenantDetail.apiRateLimit': 'Limite de Tasa API',
  'tenantDetail.apiRateLimitDesc': 'Aplicar limites de tasa a solicitudes API',
  'tenantDetail.dataExport': 'Permiso de Exportacion',
  'tenantDetail.dataExportDesc': 'Permitir a este inquilino exportar sus datos',
  'tenantDetail.auditAccess': 'Acceso a Auditoria',
  'tenantDetail.auditAccessDesc': 'Permitir ver sus propios registros de auditoria',
  'tenantDetail.saveIsolation': 'Guardar Politica de Aislamiento',
  'tenantDetail.currentPlan': 'Costo del Plan Actual',
  'tenantDetail.perMonth': '/ mes',
  'tenantDetail.nextBilling': 'Proxima factura',
  'tenantDetail.billDetail': 'Detalle de Factura',
  'tenantDetail.baseFee': 'Tarifa Base',
  'tenantDetail.apiCallFee': 'Tarifa Llamadas API',
  'tenantDetail.storageFee': 'Tarifa Almacenamiento',
  'tenantDetail.supportFee': 'Tarifa Soporte',
  'tenantDetail.total': 'Total',
  'tenantDetail.historyBills': 'Historial de Facturas',
  'tenantDetail.paid': 'Pagado',
  'tenantDetail.download': 'Descargar',
  'tenantDetail.feature.aiModels': 'Modelos IA',
  'tenantDetail.feature.apiAccess': 'Acceso API',
  'tenantDetail.feature.advancedAnalytics': 'Analisis Avanzado',
  'tenantDetail.feature.basicAnalytics': 'Analisis Basico',
  'tenantDetail.feature.customDomain': 'Dominio Personalizado',
  'tenantDetail.feature.sso': 'SSO',
  'tenantDetail.feature.whiteLabel': 'Marca Blanca',
  'users.title': 'Usuarios y Permisos',
  'users.subtitle': 'Gestionar cuentas de usuario y permisos de todos los inquilinos',
  'users.addUser': 'Agregar Usuario',
  'users.totalUsers': 'Total Usuarios',
  'users.activeUsers': 'Usuarios Activos',
  'users.admins': 'Administradores',
  'users.developers': 'Desarrolladores',
  'users.loading': 'Cargando...',
  'userFilters.search': 'Buscar nombre, email o inquilino...',
  'userFilters.allRoles': 'Todos los Roles',
  'userFilters.admin': 'Administrador',
  'userFilters.user': 'Usuario',
  'userFilters.developer': 'Desarrollador',
  'userFilters.allStatus': 'Todos los Estados',
  'userFilters.active': 'Activo',
  'userFilters.inactive': 'Inactivo',
  'userFilters.moreFilters': 'Mas Filtros',
  'userTable.user': 'Usuario',
  'userTable.tenant': 'Inquilino',
  'userTable.role': 'Rol',
  'userTable.status': 'Estado',
  'userTable.lastLogin': 'Ultimo Inicio',
  'userTable.actions': 'Acciones',
  'userTable.role.admin': 'Administrador',
  'userTable.role.user': 'Usuario',
  'userTable.role.developer': 'Desarrollador',
  'userTable.status.active': 'Activo',
  'userTable.status.inactive': 'Inactivo',
  'resources.title': 'Configuracion de Servicios',
  'resources.subtitle': 'Gestionar modelos IA, claves API e integraciones',
  'resources.refresh': 'Actualizar',
  'resources.addConfig': 'Agregar Config',
  'resources.totalConfigs': 'Total Configs',
  'resources.active': 'Activo',
  'resources.categories': 'Categorias',
  'resources.secrets': 'Secretos',
  'resources.addTitle': 'Nueva Configuracion',
  'resources.category': 'Categoria',
  'resources.configKey': 'Clave Config',
  'resources.displayName': 'Nombre para Mostrar',
  'resources.value': 'Valor',
  'resources.description': 'Descripcion',
  'resources.secretValue': 'Valor secreto',
  'resources.type': 'Tipo:',
  'resources.save': 'Guardar',
  'resources.cancel': 'Cancelar',
  'resources.create': 'Crear',
  'resources.configs': 'configs',
  'resources.items': 'elementos',
  'resources.notConfigured': 'No Configurado',
  'resources.noConfigs': 'No se encontraron configuraciones',
  'resources.running': 'En ejecucion',
  'resources.maintenance': 'En mantenimiento',
  'resources.endpoint': 'Punto final',
  'resources.usageTenants': 'Inquilinos usando',
  'resources.usageUnit': '',
  'resources.usage': 'Uso',
  'resources.configure': 'Configurar',
  'resources.stats': 'Estadisticas',
  'resources.modelType': 'Tipo',
  'resources.version': 'Version',
  'resources.callCount': 'Llamadas',
  'resources.cost': 'Costo',
  'resources.apiKey': 'Clave API',
  'resources.edit': 'Editar',
  'resources.usageStats': 'Estadisticas de Uso',
  'settings.title': 'Configuracion del Sistema',
  'settings.subtitle': 'Gestionar configuracion global, seguridad y localizacion',
  'settings.tab.general': 'General',
  'settings.tab.services': 'Servicios',
  'settings.tab.security': 'Seguridad',
  'settings.tab.notification': 'Notificaciones',
  'settings.tab.billing': 'Planes',
  'settings.tab.locale': 'Idiomas',
  'settings.systemInfo': 'Info del Sistema',
  'settings.version': 'Version',
  'settings.environment': 'Entorno',
  'settings.production': 'Produccion',
  'settings.availability': 'Disponibilidad',
  'settings.lastBackup': 'Ultima Copia',
  'settings.todayAt': 'Hoy 03:00',
  'general.platformInfo': 'Informacion de la Plataforma',
  'general.platformName': 'Nombre de la Plataforma',
  'general.platformUrl': 'URL de la Plataforma',
  'general.supportEmail': 'Email de Soporte',
  'general.timezone': 'Zona Horaria',
  'general.dateFormat': 'Formato de Fecha',
  'general.maxTenants': 'Max Inquilinos / Plan',
  'general.sessionMaintenance': 'Sesion y Mantenimiento',
  'general.sessionTimeout': 'Tiempo de Sesion',
  'general.sessionTimeoutDesc': 'Cierre automatico por inactividad',
  'general.minutes': 'minutos',
  'general.maintenanceMode': 'Modo Mantenimiento',
  'general.maintenanceDesc': 'Los usuarios veran una pagina de mantenimiento',
  'general.maintenanceWarning': 'Modo mantenimiento activado. Los usuarios no pueden acceder a la plataforma.',
  'general.reset': 'Restablecer',
  'general.save': 'Guardar',
  'general.saved': 'Guardado',
  'security.authPolicy': 'Politica de Autenticacion',
  'security.mfa': 'MFA Obligatorio',
  'security.mfaDesc': 'Todas las cuentas de administrador deben habilitar MFA',
  'security.sso': 'SSO',
  'security.ssoProtocol': 'Protocolo actual',
  'security.passwordPolicy': 'Politica de Contrasenas',
  'security.minLength': 'Longitud Minima',
  'security.chars': 'caracteres',
  'security.expireDays': 'Expiracion de Contrasena',
  'security.days': 'dias',
  'security.maxAttempts': 'Intentos Max de Inicio',
  'security.times': 'veces',
  'security.lockoutDuration': 'Duracion de Bloqueo',
  'security.ipWhitelist': 'Lista Blanca IP',
  'security.ipPlaceholder': 'Ingresar IP o CIDR, ej: 192.168.1.0/24',
  'security.add': 'Agregar',
  'security.ipWhitelistDesc': 'Solo las IPs de la lista blanca podran acceder al panel de administracion.',
  'security.auditLog': 'Registro de Auditoria',
  'security.retentionDays': 'Dias de Retencion',
  'security.retentionDesc': 'Los registros mas antiguos se eliminaran automaticamente',
  'security.reset': 'Restablecer',
  'security.save': 'Guardar',
  'security.saved': 'Guardado',
  'notification.channels': 'Canales de Notificacion',
  'notification.email': 'Notificaciones por Email',
  'notification.emailDesc': 'Enviar alertas e informes por email',
  'notification.sms': 'Notificaciones SMS',
  'notification.smsDesc': 'Enviar alertas urgentes por SMS',
  'notification.webhook': 'Webhook',
  'notification.webhookDesc': 'Enviar eventos a una URL especificada',
  'notification.webhookUrl': 'URL Webhook',
  'notification.alertEvents': 'Eventos de Alerta',
  'notification.tenantCreate': 'Nuevo Registro de Inquilino',
  'notification.tenantCreateDesc': 'Notificar cuando un nuevo inquilino se registre',
  'notification.quotaExceed': 'Alerta de Cuota Excedida',
  'notification.quotaExceedDesc': 'Notificar cuando el uso API supere el 90%',
  'notification.loginFail': 'Alerta de Fallo de Inicio',
  'notification.loginFailDesc': 'Notificar cuando los fallos de inicio alcancen el umbral',
  'notification.systemError': 'Alerta de Error del Sistema',
  'notification.systemErrorDesc': 'Notificar inmediatamente ante errores criticos',
  'notification.scheduledReport': 'Informes Programados',
  'notification.dailyReport': 'Informe Diario',
  'notification.dailyReportDesc': 'Enviar resumen diario de datos operativos',
  'notification.sendTime': 'Hora de Envio',
  'notification.recipients': 'Destinatarios',
  'notification.emailPlaceholder': 'Ingresar email',
  'notification.addBtn': 'Agregar',
  'notification.reset': 'Restablecer',
  'notification.save': 'Guardar',
  'notification.saved': 'Guardado',
  'billing.saved': 'Plan guardado',
  'billing.totalPlans': 'Total Planes',
  'billing.activePlans': 'Planes Activos',
  'billing.highestPrice': 'Precio Mas Alto',
  'billing.editing': 'Editando',
  'billing.cancel': 'Cancelar',
  'billing.save': 'Guardar',
  'billing.planName': 'Nombre del Plan',
  'billing.monthlyFee': 'Tarifa Mensual (CNY)',
  'billing.apiCallsMonth': 'Llamadas API / Mes',
  'billing.storageSpace': 'Almacenamiento (GB)',
  'billing.maxUsers': 'Max Usuarios',
  'billing.supportType': 'Tipo de Soporte',
  'billing.disabled': 'Desactivado',
  'billing.perMonth': '/ mes',
  'billing.edit': 'Editar',
  'billing.apiLabel': 'Llamadas API',
  'billing.storageLabel': 'Almacenamiento',
  'billing.usersLabel': 'Usuarios',
  'billing.supportLabel': 'Soporte',
  'locale.defaultLang': 'Configuracion de Idioma Predeterminado',
  'locale.platformDefault': 'Idioma Predeterminado',
  'locale.platformDefaultDesc': 'Idioma usado para nuevos visitantes',
  'locale.fallbackLang': 'Idioma de Respaldo',
  'locale.fallbackLangDesc': 'Usado cuando falta la traduccion',
  'locale.autoDetect': 'Deteccion Auto de Idioma',
  'locale.autoDetectDesc': 'Cambiar automaticamente segun el navegador',
  'locale.tenantOverride': 'Permitir Idioma Personalizado del Inquilino',
  'locale.tenantOverrideDesc': 'Los inquilinos pueden anular el idioma predeterminado',
  'locale.langManagement': 'Gestion de Paquetes de Idioma',
  'locale.enabled': 'habilitados',
  'locale.default': 'Predeterminado',
  'locale.translationCoverage': 'Cobertura de Traduccion',
  'locale.cannotDisable': 'El idioma predeterminado no se puede desactivar',
  'locale.coverageNote': 'Nota sobre Cobertura',
  'locale.coverageDesc': 'Paquetes con cobertura inferior al 80% pueden mostrar algunos elementos en el idioma de respaldo.',
  'locale.save': 'Guardar',
  'locale.saved': 'Guardado',
  'serviceConfigs.title': 'Configuracion de Servicios',
  'serviceConfigs.subtitle': 'Gestionar modelos IA, claves API e integraciones externas',
  'serviceConfigs.refresh': 'Actualizar',
  'audit.title': 'Registro de Auditoria',
  'audit.subtitle': 'Registros de operaciones y auditoria de seguridad',
  'audit.totalLogs': 'Total Registros',
  'audit.totalLogsDesc': 'Todos los registros',
  'audit.successOps': 'Operaciones Exitosas',
  'audit.successRate': 'Tasa de exito',
  'audit.failedOps': 'Operaciones Fallidas',
  'audit.failedDesc': 'Requiere atencion',
  'audit.todayOps': 'Operaciones Hoy',
  'audit.todayDesc': 'Actividad del dia',
  'audit.tenant': 'Inquilino',
  'audit.allTenants': 'Todos los Inquilinos',
  'audit.actionType': 'Tipo de Accion',
  'audit.allActions': 'Todas las Acciones',
  'audit.status': 'Estado',
  'audit.allStatus': 'Todos los Estados',
  'audit.success': 'Exitoso',
  'audit.failed': 'Fallido',
  'audit.timeRange': 'Periodo',
  'audit.allTime': 'Todo el Tiempo',
  'audit.today': 'Hoy',
  'audit.last7days': 'Ultimos 7 dias',
  'audit.last30days': 'Ultimos 30 dias',
  'audit.keyword': 'Busqueda por Palabra Clave',
  'audit.keywordPlaceholder': 'Buscar usuario, accion, recurso...',
  'audit.found': '',
  'audit.records': 'registros encontrados',
  'audit.clearFilter': 'Limpiar filtros',
  'audit.time': 'Hora',
  'audit.user': 'Usuario',
  'audit.action': 'Accion',
  'audit.resource': 'Recurso',
  'audit.ipAddress': 'Direccion IP',
  'audit.actions': 'Acciones',
  'audit.viewDetail': 'Ver detalles',
  'audit.showing': 'Mostrando',
  'audit.prevPage': 'Anterior',
  'audit.nextPage': 'Siguiente',
  'audit.detailTitle': 'Detalles de Operacion',
  'audit.logId': 'ID Registro',
  'audit.operationTime': 'Hora de Operacion',
  'audit.operationStatus': 'Estado de Operacion',
  'audit.tenantInfo': 'Info Inquilino',
  'audit.tenantId': 'ID Inquilino',
  'audit.tenantName': 'Nombre Inquilino',
  'audit.operationUser': 'Usuario',
  'audit.userId': 'ID Usuario',
  'audit.userName': 'Nombre Usuario',
  'audit.operationInfo': 'Info Operacion',
  'audit.operationType': 'Tipo de Operacion',
  'audit.operationResource': 'Recurso',
  'audit.operationDetail': 'Detalles',
  'audit.networkInfo': 'Info de Red',
  'audit.userAgent': 'User Agent',
  'reports.title': 'Informes y Analisis',
  'reports.subtitle': 'Analisis multidimensional e informes visuales',
  'reports.last7days': 'Ultimos 7 dias',
  'reports.last30days': 'Ultimos 30 dias',
  'reports.last90days': 'Ultimos 90 dias',
  'reports.apiTrend': 'Tendencia Llamadas API',
  'reports.revenueCompare': 'Comparacion Ingresos',
  'reports.resourceUsage': 'Uso de Recursos',
  'reports.userActivity': 'Actividad de Usuarios',
  'reports.activeUsers': 'Usuarios Activos',
  'reports.newUsers': 'Nuevos Usuarios',
  'reports.tenantSummary': 'Resumen de Datos',
  'reports.tenantName': 'Nombre Inquilino',
  'reports.apiCalls': 'Llamadas API',
  'reports.storageUsage': 'Uso Almacenamiento',
  'reports.userCount': 'Usuarios',
  'reports.revenue': 'Ingresos',
  'reports.quotaUsage': 'Uso de Cuota',
  'langSwitcher.title': 'Idioma / Language',
};
